// extracted by mini-css-extract-plugin
export default {"button":"PassChangeMockPage_button__hIsWz"};